import * as React from 'react';
import cx from 'classnames';

import { ControlLinkButton } from '../../ControlLinkButton';
import { Listing } from '../../Icons';

import * as styles from './styles.css';

interface IListingButtonProps {
  url: string;
  onClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void;
}

export function ListingButton({ url, onClick }: IListingButtonProps) {
  return (
    <ControlLinkButton href={url} className={cx(styles['navigation-btn'], styles['listing-btn'])} onClick={onClick}>
      <Listing />
      <span className={styles['listing-title']}>Список</span>
    </ControlLinkButton>
  );
}
